<script>
	import { onMount, createEventDispatcher } from "svelte";
	import objectStore from "./store.js";

	export let tabs;

	const dispatch = createEventDispatcher();

	export let tabVal = 0;
	export let useStore = false;

	let selection = 140;
	let ready = false;

	onMount(() => {
		ready = true;
	});

	function checkEnabled() {
		if (useStore) {
			return $objectStore.available;
		} else {
			return true;
		}
	}
	async function tabChange(val) {
		if (checkEnabled()) {
			tabVal = val;
			dispatch("tabchange", {
				text: tabVal,
			});
		} else {
			console.log("tabs disabled");
		}
	}
</script>

<!-- {#if ready}
	<div class="ios13-segmented-control">
		<span class="selection user-color-background" style="transform:translateX({selection * tabVal}px)"></span>
		{#each tabs as tab,i}
			<div class="option {tabVal===i ? 'active':''} {tabVal-1===i ? 'previous':''}" on:click={()=>tabChange(i)}>
			<div><span>{tab.label}</span></div>
			</div>
		{/each}
	</div>
{/if} -->
<style>
	.ios13-segmented-control {
		border-radius: 9px;
		margin-top: 15px;
		height: 28px;
		border: none;
		outline: none;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-around;
		align-items: stretch;
		background-color: #eee;
		z-index: 0;
	}
	.ios13-segmented-control .option {
		position: relative;
		outline: none;
		background: transparent;
		cursor: pointer;
		text-decoration: none;
		-webkit-tap-highlight-color: transparent;
		padding-top: 2px;
	}

	.ios13-segmented-control .option div {
		position: relative;
		display: block;
		text-align: center;
		width: 136px;
		z-index: 2;
		box-sizing: border-box;
	}

	.ios13-segmented-control .option:last-child div {
		border-right: none !important;
	}

	.ios13-segmented-control .option div span {
		font-size: 12px;
		font-weight: 400;
		color: #000;
		z-index: 4;
		user-select: none;
		outline: none;
	}

	.ios13-segmented-control .selection {
		background: rgba(255, 255, 255, 1);
		box-shadow:
			0 0px 2px 2px rgba(0, 0, 0, 0.12),
			0 2px 1px 0 rgba(0, 0, 0, 0.04);
		border-radius: 6px;
		z-index: 2;
		will-change: transform;
		-webkit-transition: transform 0.2s ease;
		transition: transform 0.2s ease;
		position: absolute;
		left: calc(50% - 140px);
		height: 24px;
		width: 136px;
		top: 17px;
		margin-top: 21px;
	}
</style>
